export default __webpack_public_path__ + "static/media/5.a9ca84e0.png";